import { render, staticRenderFns } from "./AlertTemplate.vue?vue&type=template&id=2e153dec"
import script from "./AlertTemplate.vue?vue&type=script&lang=js"
export * from "./AlertTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports